import Common from '../../Common';

type AudioType = 'mp3'

const Stored = class extends Common {
	download = (recordingId: id, audioType: AudioType = 'mp3'): CustomResponse<Blob> =>
		this.get(`/recording/stored/${recordingId}/${audioType}`, {}, { responseType: 'blob' })

	delete = (recordingId: id) =>
		this.doDelete(`/recording/stored/${recordingId}`)
}

export default Stored
